import VueRouter from "vue-router";

import Vue from "vue";


import deviceActivate from "../components/deviceActivate.vue";
import fbDeviceUser from "../components/fbDeviceUser.vue";
import syncStatus from "../components/syncStatus.vue";

import dailyRetention from "../components/dailyRetention.vue";
import retention from "../components/retention.vue";// 新的retention


import subsRetention from "../components/subsRetention.vue";    // 账号别 subsRetention 
import subsPause from "../components/subsPause.vue";    //  subsPause  订阅暂停的情况
import subsTrial from "../components/subsTrial.vue";    //  stripe后台相关 账号别试用情况 subsTrial
import subsList from "../components/subsList.vue";//  subsList 按照条件列出关联 Subscription

import unlinkedCard from "../components/unlinkedCard.vue";   //  untrialedBalance
import activateAndBinding from "../components/activateAndBinding.vue"; //新写的激活与绑卡    //  activeAndBinding

import trialConversion from "../components/trialConversion.vue";   //  trialConversion



import churnRate from "../components/churnRate.vue";   //  churnRate 新的 , 支持车型选择和周期选择



//骑行报告相关
import activeReport from "../components/activeReport.vue";         ///activeReport 新做的活跃报告
import activeDistribution from "../components/activeDistribution.vue";    //  activeDistribution
import aiCourse from "../components/aiCourse.vue";    //  aiCourse
import activeDistributionApp from "../components/activeDistributionApp.vue";    //  activeDistributionApp
import engagementPercentage from "../components/engagementPercentage.vue";     //   engagementPercentage
import activeNewOld from "../components/activeNewOld.vue";       //activeNewOld
import subsActivePercential  from "../components/subsActivePercential.vue";   //   设备别活跃数据分布       //  subsActivePercential 



//cohort 相关   
import cohortSubs from "../components/cohortSubs.vue";         //   cohortSubs
import cohortBingding from "../components/cohortBingding.vue";   //按照车型查看绑卡cohort//  cohortBingding   
//  coachPerf   教练表选相关 
import coachPerf from "../components/coachPerf.vue";         //   coachPerf 教练表选相关

//设备相关  
import devices from "../components/devices.vue";                  //  devices 
import deviceInfo from "../components/deviceInfo.vue";          //  deviceInfo  
import deviceSelector from "../components/deviceSelector.vue";        //      deviceSelector
import deviceRelation from "../components/deviceRelation.vue";   //  deviceRelation
import whitelist from "../components/whitelist.vue";    //设备白名单相关   whitelist

//  用户管理相关的
import userWhitelist from "../components/userWhitelist.vue";     //   用户白名单管理        // userWhitelist 

//系统管理相关
import devLog from "../components/devLog.vue";
import dashLog from "../components/dashLog.vue";
import login from "../components/login.vue";
import requestApiTest  from "../components/requestApiTest .vue";//requestApiTest 
import tools from "../components/tools.vue";

import initDevice from "../components/initDevice.vue";//initDevice同步设备基础信息 // 终极版本

import syncDevice from "../components/syncDevice.vue";
import initStatus from "../components/initStatus.vue";
import initTrial from "../components/initTrial.vue";
import initSubscribe from "../components/initSubscribe.vue";
import syncData from "../components/syncData.vue";



//  注册vuerouter
Vue.use(VueRouter)

//定义一个单参数的分析结果路由


//  创建一个路由对象,并且设置对应关系
const router = new VueRouter({
    // 指定hash 属性 和组件的对应关系
    routes: [

        //增加一个重定向
        { path: '/', redirect: '/devLog' },



        { path: '/deviceActivate', component: deviceActivate },
        { path: '/fbDeviceUser', component: fbDeviceUser },
        { path: '/syncStatus', component: syncStatus },
        { path: '/dailyRetention', component: dailyRetention },


        { path: '/unlinkedCard/:bike_type', name: 'unlinkedCard', component: unlinkedCard },
        { path: '/activateAndBinding', name: 'activateAndBinding', component: activateAndBinding },    //新写的激活与绑卡    //  activateAndBinding

        //  新的retention,==>带两个参数  
        { path: '/retention/:bike_type/:cycle', name: 'retention', component: retention },

        { path: '/subsRetention', name: 'subsRetention', component: subsRetention },              // 账号别 subsRetention 
        { path: '/subsPause', name: 'subsPause', component: subsPause },  //  subsPause  订阅暂停的情况
        { path: '/subsTrial', name: 'subsTrial', component: subsTrial },    //  stripe后台相关 账号别试用情况 subsTrial
        { path: '/subsList', name: 'subsList', component: subsList },   //  subsList 按照条件列出关联 Subscription

        //查看试用转化率相关信息   
        { path: '/trialConversion/:bike_type/:filter', name: 'trialConversion', component: trialConversion },



        //查看流失率相关信息   
        { path: '/churnRate/:bike_type/:cycle', name: 'churnRate', component: churnRate },




        //骑行相关模块  
        { path: '/activeReport', name: 'activeReport', component: activeReport }, //24年3月新作的活跃报告 
        { path: '/activeDistribution', name: 'activeDistribution', component: activeDistribution },    //  activeDistribution 
        { path: '/aiCourse', name: 'aiCourse', component: aiCourse },     //  aiCourse   AI 课程的参与情况 
        { path: '/activeDistributionApp/:cycle/:bike_type', name: 'activeDistributionApp', component: activeDistributionApp },    //  activeDistributionApp 
        { path: '/activeNewOld', name: 'activeNewOld', component: activeNewOld },  //区分新老设备的骑行信息详细  activeNewOld  
        { path: '/subsActivePercential', name: 'subsActivePercential', component: subsActivePercential  },  //   设备别活跃数据分布       //  subsActivePercential 
        { path: '/engagementPercentage/:course_kind/:bike_type/:filter', name: 'engagementPercentage', component: engagementPercentage },    //  engagementPercentage  justRide/all/true


        //这里是cohort 相关模块
        { path: '/cohortSubs/:bike_type', name: 'cohortSubs', component: cohortSubs }, //按照车型查看订阅cohort 信息   
        { path: '/cohortBingding', name: 'cohortBingding', component: cohortBingding }, //按照车型查看订阅cohort//  cohortBingding   




        //  下面是教练表现课程相关
        { path: '/coachPerf/:month', name: 'coachPerf', component: coachPerf }, //   按照年月获取教练表现课程

        //  下面是白名单 及设备管理相关模块  
        { path: '/devices', name: 'devices', component: devices },             //devices 
        { path: '/deviceInfo', name: 'deviceInfo', component: deviceInfo },             //deviceInfo /:deviceNumber
        { path: '/deviceSelector', name: 'deviceSelector', component: deviceSelector },        //  deviceSelector  
        { path: '/deviceRelation', name: 'deviceRelation', component: deviceRelation }, //  deviceRelation
        { path: '/whitelist', name: 'whitelist', component: whitelist }, //   白名单管理

//下面是用户管理相关的

{ path: '/userWhitelist', name: 'userWhitelist', component: userWhitelist }, //   用户白名单管理        // userWhitelist 

        //下面是系统管理大模块
        { path: '/devLog', component: devLog }, //开发日志  
        { path: '/login', component: login }, //用户登录
        { path: '/dashLog', component: dashLog }, // dashLog  日志管理
        { path: '/requestApiTest ', component: requestApiTest  },//requestApiTest 
        { path: '/tools', component: tools }, //  实用工具    tools

        //下面是同步信息相关
        { path: '/initDevice', component: initDevice },    //initDevice同步设备基础信息 // 终极版本
        { path: '/syncDevice', component: syncDevice },    //同步设备基础信息
        { path: '/initStatus', component: initStatus },    //initStatus  初始化状态数组
        { path: '/initTrial', component: initTrial },       //"/initTrial"
        { path: '/initSubscribe', component: initSubscribe },     //initSubscribe   更新订阅状态信息
        { path: '/syncData', component: syncData },     //initSubscribe   更新订阅状态信息



    ]

})

//注意 需要导出 router对象 
export default router


